import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {OrderService} from "@services/order.service";

@Component({
  selector: 'nav-steps',
  templateUrl: './nav-steps.component.html',
  styleUrls: ['./nav-steps.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavStepsComponent implements OnInit {
  steps: any[];
  currentStep: any;

  @Input() shop: string;

  constructor(
    private router: Router,
    private orderService: OrderService,
  ) { }

  ngOnInit(): void {
    this.orderService.stepsBS.subscribe(steps => {
      this.steps = steps;
    })
    this.orderService.currentStepBS.subscribe(currentStep => {
        this.currentStep = currentStep;
    })
  }

  // goTo(route: string) {
  //   this.router.navigateByUrl(route).then();
  // }
}
